import { render, staticRenderFns } from "./InventoryWarehouseSummary.vue?vue&type=template&id=405b52e3&"
import script from "./InventoryWarehouseSummary.vue?vue&type=script&lang=js&"
export * from "./InventoryWarehouseSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports